import { useRef as r, useEffect as s } from "react";
const o = (t, f) => {
  const e = r(!1);
  s(() => {
    e.current ? t() : e.current = !0;
  }, f);
};
export {
  o as default
};
//# sourceMappingURL=useAfterMount.js.map
